import React, { Component } from 'react'
import axios from 'axios'
import _ from 'lodash'
import { backendURL } from '../../data/config.json'

//Message Box
import Message from '../Message'

//Loader
import Loader from '../Loader'

import Recaptcha from 'react-recaptcha'

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        type: 'Contact',
        title: 'Contact', 
      },
      loading: false,
      formIsValid: false,
      resText: '',
      sent: false,
      error: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleHighlightEmptyValues = this.handleHighlightEmptyValues.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    this.props.items.map((item, index) => {
      this.setState(prevstate => {
        return {
          ...prevstate,
          data: {
            ...prevstate.data,
            [item.node.fieldname]: '',
          },
        }
      })
    })
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState(prevstate => {
      return {
        ...prevstate,
        data: {
          ...prevstate.data,
          [name]: value,
        },
      }
    })
    console.log(this.state)
  }

  handleHighlightEmptyValues(value) {
    if (this.state.emptyValues && _.isEmpty(value)) {
      return 'inputNormal inputError'
    }
    return 'inputNormal'
  }

  hasEmptyValue() {
    const { type, firstname, lastname, Subject, email, message } = this.state.data
    const emptyValues = _.some(
      [type, firstname, lastname, Subject, email, message],
      value => value === ''
    )
    if (emptyValues) {
      return true
    }
    return false
  }

  handleSubmit(event) {
    event.preventDefault()
    if (this.hasEmptyValue()) {
      this.setState({
        emptyValues: true,
        resText:
          'There are errors in the form. Please correct them and resubmit the form.',
      })
    } else {
      this.setState({ emptyValues: false, loading: true })
      axios({
        method: 'post',
        data: this.state.data,
        url: `${backendURL}/api/contactForms/add`,
      })
        .then(res => {
          console.log(res)
          this.setState({
            loading: false,
            sent: true,
            resText: 'Thank you. Your information has been sent',
          })
        })
        .catch(err => {
          this.setState({
            loading: false,
            error: true,
            resText:
              'Sorry we could not send your information. Please try later',
          })
          console.log(err)
        })
    }
  }

  recaptchaCallback() {
    console.log('Done!!!!')
  }

  renderFields() {
    const { lang, items } = this.props
    return _.map(items, (item, i) => {
      const { fieldname, label, required, type } = item.node
      if (type === 'textarea') return null
      return (
        <div key={i}>
          <label>{label[lang]}</label>
          <input
            type={type}
            name={fieldname}
            onChange={this.handleChange}
            className={this.handleHighlightEmptyValues(
              this.state.data[fieldname]
            )}
          />
        </div>
      )
    })
  }
  renderTextAreas() {
    const { lang, items } = this.props
    return _.map(items, (item, i) => {
      const { fieldname, label, required, type } = item.node
      if (type === 'textarea') {
        return (
          <div key={i}>
            <label>{label[lang]}</label>
            <textarea
              name={fieldname}
              onChange={this.handleChange}
              className={this.handleHighlightEmptyValues(
                this.state.data[fieldname]
              )}
            />
          </div>
        )
      }
      return null
    })
  }

  render() {
    const { lang } = this.props

    //render message respond
    let respondField = null
    if (this.state.loading) {
      respondField = <Loader />
    }
    if (this.state.sent || this.state.error || this.state.emptyValues) {
      respondField = <Message text={this.state.resText} />
    }

    return (
      <form className="ContactFrom" onSubmit={this.handleSubmit}>
        <div className="firstBlock">{this.renderFields()}</div>
        <div className="secondBlock">{this.renderTextAreas()}</div>
        <div className="recaptcha-class">
          <Recaptcha sitekey="6LccKWsUAAAAAOALqGeqc33LprinhR3FnIlrKEX4" />
        </div>
        {respondField}
        <div>
          <button className="btn">{lang === 'en' ? 'Submit' : 'Enviar'}</button>
        </div>
      </form>
    )
  }
}
export default ContactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js